<section class="wraper-sub">
  <div class="unpaid-order-m">
    <div class="top-page-m">
      <div class="top-section">
        <div class="headTab d-flex align-items-center">
            <h2 class="page-name">
                  All Packages
            </h2>
            <!-- foreach(statusArray as status)
              <span class="status-pill" [ngClass]="{'active': searchParams.status === status.value}" (click)="setStatusFilter(status.value)">{{ status.name }}</span>
            <h1 class="page-name" [ngClass]="{'active': isMySubTab}" (click)="switchSubTab(true);">My leads</h1> -->
        </div>
        

        <div class="price-top-m">
          <p class="price-sub" data-toggle="modal" data-target="#year_selection">
            <span>$ {{ leads.totalPay | number }}</span>
            <i class="fa fa-caret-down" aria-hidden="true" *ngIf="leads.totalPay > 0"></i>
          </p>

          <div class="year-selection-m" *ngIf="leads.totalPay > 0">
            <!-- Modal -->
            <div class="modal fade" id="year_selection" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
              <div class="modal-dialog" role="document">
                <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                  <span aria-hidden="true">&times;</span>
                </button>
                <div class="modal-header">
                  <h5 class="modal-title" id="exampleModalLabel">Total : $ {{ leads.totalPay | number }}</h5>
                </div>
                <div class="modal-content">
                  <div class="modal-body">
                    <ul class="year-selection-p">
                      <li *ngFor="let entry of leads.statusSum | keyvalue">
                        <label [title]="entry.key"><b>{{ entry.key }}</b></label>
                        <span>{{ entry.value | number }}</span>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

      </div>
      <div class="filter-sub-m">
        <div class="filter-m">
          <div class="filter">
            <div class="fields-m largeField">
              <input type="text" name="search" (change)="rerender()" [(ngModel)]="searchParams.emailId" placeholder="Search by Name, Email or Phone">
              <i class="fa fa-search" aria-hidden="true" (click)="rerender()"></i>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m date-filter">
              <input (onHidden)="splitFromTo()" [(ngModel)]="fullRangeDate" type="text" placeholder="Date Range" bsDaterangepicker [bsConfig]="{ isAnimated: true, showWeekNumbers: false}">
              <svg width="15" height="15" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M13.2422 1.17188H12.5391V0H11.3672V1.17188H3.63281V0H2.46094V1.17188H1.75781C0.788555 1.17188 0 1.96043 0 2.92969V13.2422C0 14.2114 0.788555 15 1.75781 15H13.2422C14.2114 15 15 14.2114 15 13.2422V2.92969C15 1.96043 14.2114 1.17188 13.2422 1.17188ZM13.8281 13.2422C13.8281 13.5653 13.5653 13.8281 13.2422 13.8281H1.75781C1.43473 13.8281 1.17188 13.5653 1.17188 13.2422V5.50781H13.8281V13.2422ZM13.8281 4.33594H1.17188V2.92969C1.17188 2.6066 1.43473 2.34375 1.75781 2.34375H2.46094V3.51562H3.63281V2.34375H11.3672V3.51562H12.5391V2.34375H13.2422C13.5653 2.34375 13.8281 2.6066 13.8281 2.92969V4.33594Z"
                    fill="#1C212D" />
                <path d="M3.39844 6.73828H2.22656V7.91016H3.39844V6.73828Z" fill="#1C212D" />
                <path d="M5.74219 6.73828H4.57031V7.91016H5.74219V6.73828Z" fill="#1C212D" />
                <path d="M8.08643 6.73828H6.91455V7.91016H8.08643V6.73828Z" fill="#1C212D" />
                <path d="M10.4297 6.73828H9.25781V7.91016H10.4297V6.73828Z" fill="#1C212D" />
                <path d="M12.7734 6.73828H11.6016V7.91016H12.7734V6.73828Z" fill="#1C212D" />
                <path d="M3.39844 9.08203H2.22656V10.2539H3.39844V9.08203Z" fill="#1C212D" />
                <path d="M5.74219 9.08203H4.57031V10.2539H5.74219V9.08203Z" fill="#1C212D" />
                <path d="M8.08643 9.08203H6.91455V10.2539H8.08643V9.08203Z" fill="#1C212D" />
                <path d="M10.4297 9.08203H9.25781V10.2539H10.4297V9.08203Z" fill="#1C212D" />
                <path d="M3.39844 11.4258H2.22656V12.5977H3.39844V11.4258Z" fill="#1C212D" />
                <path d="M5.74219 11.4258H4.57031V12.5977H5.74219V11.4258Z" fill="#1C212D" />
                <path d="M8.08643 11.4258H6.91455V12.5977H8.08643V11.4258Z" fill="#1C212D" />
                <path d="M10.4297 11.4258H9.25781V12.5977H10.4297V11.4258Z" fill="#1C212D" />
                <path d="M12.7734 9.08203H11.6016V10.2539H12.7734V9.08203Z" fill="#1C212D" />
              </svg>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m select-m" *ngIf="siteList && siteList.length > 0">
              <ng-select 
                [items]="siteList"
                bindLabel="abbr"
                bindValue="site_link"
                placeholder="Site"
                appendTo="body"
                [(ngModel)]="searchParams.site_link"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="true"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.abbr }}
                </ng-template>
              </ng-select>
            </div>
          </div>
          <div class="filter">
            <div class="fields-m select-m" *ngIf="statusList && statusList.length > 0">
              <ng-select 
                [items]="statusList"
                bindLabel="name"
                bindValue="value"
                placeholder="Status"
                appendTo="body"
                [(ngModel)]="searchParams.status"
                [ngModelOptions]="{standalone: true}"
                [searchable]="false"
                [clearable]="true"
                (change)="rerender()"
                >
                <ng-template ng-option-tmp let-item="item" let-index="index">
                  {{ item.name }}
                </ng-template>
              </ng-select>
            </div>
          </div>
        <div class="filter">
            <div class="fields-m select-m" *ngIf="selectedIds.length > 0" class="mb-2">
              <button class="btn btn-danger" (click)="deleteSelected()">Delete Selected</button>
            </div>
          </div>
          <div class="clear-m">
            <div class="clear" (click)="clearFilters()">
              <span>Clear</span>
              <svg width="17" height="16" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path
                    d="M16.502 14.4612L11 14.5L16.3175 8.9606C16.7574 8.50197 16.9996 7.89224 16.9996 7.24366C16.9996 6.59515 16.7574 5.98539 16.3175 5.52676L12.178 1.21004C11.2701 0.263319 9.79293 0.263319 8.88506 1.21004L0.682059 9.76415C0.242217 10.2228 0 10.8325 0 11.4811C0 12.1296 0.242217 12.7394 0.682059 13.198L2.74371 15.3479C2.83711 15.4453 2.96378 15.5 3.09586 15.5H16.502C16.777 15.5 17 15.2675 17 14.9806C17 14.6938 16.777 14.4612 16.502 14.4612ZM7.83365 3.77541L9.14441 5.14226L5.12739 9.33125L3.81663 7.96439L7.83365 3.77541ZM11.8424 7.95567L7.82531 12.1446L5.8317 10.0657L9.84874 5.87674L11.8424 7.95567ZM12.5467 8.69015L13.8575 10.057L12.5138 11.4583L9.84048 14.246L8.52965 12.8791L12.5467 8.69015ZM9.58943 1.94452C10.1089 1.40283 10.9542 1.40283 11.4737 1.94452L15.6132 6.26124C16.1327 6.80297 16.1327 7.68442 15.6132 8.22612L14.5618 9.32256L8.53798 3.04093L9.58943 1.94452ZM1.38636 12.4635C1.13468 12.2011 0.996094 11.8521 0.996094 11.4811C0.996094 11.11 1.13468 10.7611 1.38633 10.4987L3.11226 8.69887L4.77514 10.4329L7.47309 13.2464L8.63816 14.4612H3.30215L1.38636 12.4635Z"
                    fill="#1C212D" />
              </svg>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="data-tables-m">
      <div class="table-responsive">
        <ng-container >
           <table class="row-border hover" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger">
          <thead>
            <tr>
               <th><input type="checkbox" [checked]="isAllSelected()" (change)="toggleAllSelection($event)" /></th>
              <th>Sr</th>
              <th>Timestamp</th>
              <th>Site Link</th>
              <!-- <th>Name</th>
              <th>Email</th>
              <th>Phone</th> -->
              
              
              <th>Clint Info</th>
              <th>Plan</th>
              <th>Status</th>
              <th>Balance</th>
              <th>Total Savings</th>
              <th>Total Orders</th>
              <th>Pages</th>
              <th>Last Order Date</th>
             
              <!-- <th>Comments</th> -->
            </tr>
          </thead>

          <ng-container  *ngIf="leads.data  &&  leads.data.length > 0" >
            <tbody>
              <tr *ngFor="let lead of leads.data; let indx = index">
                <td>
              <input type="checkbox" [checked]="selectedIds.includes(lead.id)" (change)="toggleSelection(lead.id)" />
            </td>
                <td>{{ leads.from + indx }}</td>

                <td>
                  <p *ngIf="lead.date">{{ lead.date | date }}</p>
                  <p *ngIf="lead.date">{{ lead.date | date:'shortTime' }}</p>
                </td>
                <td>
                  <p *ngIf="lead.site_link else noSitelink">{{ lead.site_link }}</p>
                  <ng-template #noSitelink>
                    <p>-</p>
                  </ng-template>
                </td>

                <td>
                  <ng-container *ngIf="lead.user else noUser">
                  
                    <p>{{ lead.user.first_name }}</p>
                    <p>{{ lead.user.email }}</p>
                    <p>{{ lead.user.phone }}</p>
                  </ng-container>
                  <ng-template #noUser>
                    <p>-</p>
                  </ng-template>
                </td>


                 <td>
                  <p>{{ lead.package.name }}</p>
                  <p>{{ lead.package.price }}</p>
                </td>
                
                 <td>
                  <p>
                    {{ lead.status === 'success' ? 'Active' : (lead.status === 'pending' ? 'Unpaid' : (lead.status.charAt(0).toUpperCase() + lead.status.slice(1))) }}
                  </p>
                </td>

              <td>
                <p>${{ lead.balance | number:'1.2-2' }}</p>
              </td>

              <td>
                <p *ngIf="lead.saving else nosaving" >${{ lead.saving | number:'1.2-2' }}</p>
                <ng-template #nosaving>
                  <p>-</p>
                </ng-template>
              </td>
              <td>
                <p>{{ lead.orders_count }}</p>
              </td>
              <td>
                <p *ngIf="lead.orders_sum_pages else noPage">{{ lead.orders_sum_pages }}</p>
                <ng-template #noPage>
                  <p>0</p>
                </ng-template>
              </td>
              <td>
                <p *ngIf="lead.last_order else nodate">{{ lead.last_order.date | date }}</p>
                <ng-template #nodate>
                  <p>-</p>
                </ng-template>
              </td>


               
               
              </tr>
           
            </tbody>
          </ng-container>
        </table>
        </ng-container>
       
      </div>
    </div>
  </div>
</section>

<!-- floating alert starts -->
<ng-container *ngIf="leads.alertMessage && leads.data && leads.data.length > 0">
    <div class="floatingAlert" *ngIf="floatingAlert">
        <button type="button" class="close" (click)="closeFloatingAlert();">
          <i class="fa fa-times"></i>
        </button>
        <p>{{ leads.alertMessage }}</p>
    </div>
</ng-container>
<!-- floating alert ends -->

